import { Component } from 'preact';
import { window } from '../../../env/browser';

const scriptContent = `!function(e,t,r,n,a){if(!e[a]){for(var i=e[a]=[],s=0;s<r.length;s++){var c=r[s];i[c]=i[c]||function(e){return function(){var t=Array.prototype.slice.call(arguments);i.push([e,t])}}(c)}i.SNIPPET_VERSION="1.0.1";var o=t.createElement("script");o.type="text/javascript",o.async=!0,o.src="https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/"+n+"/"+a+".js";var p=t.getElementsByTagName("script")[0];p.parentNode.insertBefore(o,p)}}(window,document,["survey","reset","config","init","set","get","event","identify","track","page","screen","group","alias"],"q5I0VB4WeqGfjd0z","delighted");`;

export default class DelightedWidget extends Component {
  componentDidMount() {
    // eslint-disable-next-line no-eval
    eval(scriptContent);
    const { locale, email } = this.props;
    const normalizeLocale = value => {
      const language = value.split('-')[0];
      if (language === 'de') {
        return 'de-f';
      }
      return language;
    };

    window.delighted.survey({
      properties: {
        locale: normalizeLocale(locale),
      },
      email,
      initialDelay: 1, // in sec
    });
  }
}
